import { formatPhoneNumber } from '../../utils/formatters';

export default function PhoneInput({
  id,
  label,
  value,
  onChange,
  placeholder = '',
  required = false,
  error = '',
  disabled = false
}) {
  const handleChange = (e) => {
    let inputValue = e.target.value;
    // Strip +1 if user tries to enter it
    inputValue = inputValue.replace(/^\+1\s*/, '');
    const formatted = formatPhoneNumber(inputValue);
    onChange(formatted);
  };

  return (
    <div className="w-full">
      <label htmlFor={id} className="block text-lg font-semibold text-charcoal mb-2">
        {label}
        {required && <span className="text-red-500 ml-1">*</span>}
      </label>
      <div className="relative flex items-stretch w-full">
        <div className="flex items-center gap-2 px-4 py-3 bg-gray-100 border-2 border-r-0 border-gray-300 rounded-l-button text-gray-500 text-lg">
          <span className="text-xl">🇺🇸</span>
          <span>+1</span>
        </div>
        <input
          type="tel"
          id={id}
          value={value}
          onChange={handleChange}
          placeholder={placeholder}
          required={required}
          disabled={disabled}
          maxLength={14}
          className={`flex-1 min-w-0 px-4 py-3 text-lg border-2 rounded-r-button focus:outline-none focus:ring-2 focus:ring-renuvia-gold transition-all ${
            error
              ? 'border-red-500 focus:ring-red-500'
              : 'border-gray-300 focus:border-renuvia-gold'
          } disabled:bg-gray-100 disabled:cursor-not-allowed`}
        />
      </div>
      {error && <p className="text-red-500 text-sm mt-1">{error}</p>}
    </div>
  );
}
